import React from "react";
import Button from "@insightfulscience/atomic-react/Button";
import Spinner from "@insightfulscience/atomic-react/Spinner";
import { Col, Row } from "@insightfulscience/atomic-react/Grid";
import Html from "@insightfulscience/smart-react/Html";
import useTracking, { CATCH } from "@insightfulscience/smart-react/useTracking";
import SmartForm from "@insightfulscience/smart-react/SmartForm";
import { AuthContainerTitle } from "@insightfulscience/atomic-react/r1/molecules/AuthContainer";
import { useLocale } from "@insightfulscience/i18";
import Block from "@insightfulscience/atomic-react/Block";
import useResultStatus from "../utils/useResultStatus";
import { initialState, validateForm } from "./form";
import register from "./action";
import routes from "../routes";

function RegistrationForm() {
	const [t] = useLocale("registration-form");
	const [regAction, isSigningUp] = useTracking(register, CATCH);
	const [action, { errors }, resetResult] = useResultStatus(regAction);

	return (
		<>
			{isSigningUp && <Spinner />}
			<AuthContainerTitle id="equalHeightSource" data-qa-selector="signUp-form-title">
				{t("FORM_TITLE")}
			</AuthContainerTitle>
			<SmartForm textRender={t} {...{ initialState, validateForm, action }} onTouched={resetResult}>
				<SmartForm.Field
					label="FIRST_NAME"
					name="firstName"
					disabled={isSigningUp}
					fieldClassName="mb-8"
					maxLength={50}
					required
					data-qa-selector="signUp-first-name-input"
				/>

				<SmartForm.Field
					label="LAST_NAME"
					name="lastName"
					disabled={isSigningUp}
					fieldClassName="mb-8"
					maxLength={50}
					required
					data-qa-selector="signUp-last-name-input"
				/>

				<SmartForm.Field
					label="COMPANY_NAME"
					name="company"
					disabled={isSigningUp}
					fieldClassName="mb-8"
					maxLength={50}
					data-qa-selector="signUp-company-input"
				/>

				<SmartForm.Field
					label="EMAIL"
					name="email"
					type="email"
					disabled={isSigningUp}
					error={errors.message}
					fieldClassName="mb-8"
					maxLength={100}
					required
					data-qa-selector="signUp-email-input"
				/>

				<SmartForm.Field
					label="PASSWORD"
					name="password"
					type="password"
					disabled={isSigningUp}
					fieldClassName="mb-8"
					maxLength={65}
					required
					data-qa-selector="signUp-password-input"
				/>

				<SmartForm.Field
					label="CONFIRM_PASSWORD"
					name="pswdConfirm"
					type="password"
					disabled={isSigningUp}
					fieldClassName="mb-8"
					maxLength={65}
					required
					data-qa-selector="signUp-password-confirm-input"
				/>

				<Row>
					<Col spacing={{ mt: 4, mb: 2 }}>
						<Block sx={{ textAlign: "center" }}>
							<Button type="submit" disabled={isSigningUp} data-qa-selector="signUp-submit-button">
								{t("GET_STARTED")}
							</Button>
						</Block>
					</Col>
				</Row>
			</SmartForm>

			<Row>
				<Col>
					<Html Tag="p" className="text-s text-center">
						{t("USER_LEGAL_CONCENT", {
							tosLink: routes.external.termsOfService,
							ppLink: routes.external.privacyPolicy,
						})}
					</Html>
				</Col>
			</Row>
		</>
	);
}

export default RegistrationForm;
